import styled from 'styled-components';

export const Content = styled.div`
  margin: 0 auto;

  line-height: 62.5%;
`;
